<p-toast>
    <div>
        <ng-template let-message pTemplate="message">

            <div class="grid">
                <div class="col-12">
                    <h3>{{message.summary}}</h3>
                </div>
                <div class="col-12">
                    <h6 [innerHTML]="message.detail"></h6>
                </div>
            </div>
        </ng-template>
    </div>
</p-toast>

<div [ngClass]="{'lock-on': displaySpinner, 'lock-off': !displaySpinner}"></div>
@if(displaySpinner){
    <p-progressSpinner strokeWidth="5" class="spinner-load"></p-progressSpinner>
}

<router-outlet></router-outlet>